import { BREAKPOINT_MEDIUM } from 'global-search-shared';
import styled from 'styled-components';
export const StyledSearchIcon = styled.svg.withConfig({
  displayName: "StyledSearchIcon",
  componentId: "sc-6sy7bx-0"
})(["width:16px;height:16px;fill:var(--search-icon-fill);position:absolute;top:50%;transform:translateY(-50%);left:", ";pointer-events:none;z-index:2;@media (max-width:", "px){left:", ";}"], ({
  theme
}) => theme.space['500'], BREAKPOINT_MEDIUM - 1, ({
  theme
}) => theme.space['300']);